import React from 'react';
import { Calendar } from 'lucide-react';
import { CATEGORIES, COLORS } from '@/data';
import type { Clip } from '@/types';

interface ActivityDragPreviewProps {
  clip: Clip | undefined;
}

export const ActivityDragPreview: React.FC<ActivityDragPreviewProps> = ({
  clip,
}) => {
  const category = clip ? CATEGORIES.find(c => c.id === clip.categoryId) : null;

  return (
    <div
      className="bg-zinc-800 rounded-lg p-3 shadow-2xl border-2 flex items-center gap-3 w-64"
      style={{ borderColor: COLORS.lime }}
    >
      {/* Category emoji */}
      <span className="text-2xl flex-shrink-0">{category?.emoji || '📎'}</span>

      {/* Activity info */}
      <div className="flex-1 min-w-0">
        <p className="text-white text-sm font-semibold truncate">
          {clip?.title || 'Unknown'}
        </p>
        <p className="text-zinc-400 text-xs flex items-center gap-1">
          <Calendar className="w-3 h-3" />
          Moving to new date
        </p>
      </div>
    </div>
  );
};
